import React from 'react';
import type { TFunction } from 'i18next';

import { VisitorPassQueryResponse } from 'constants-visitor-management';

import { INVITE_NAME_MAX_DISPLAY_LENGTH } from '../../constants';
import { TruncateTextComponent } from '../../components/TruncateText/TruncateText';

export type VisitorLogInviteNameColumn = {
  header: string;
  key: string;
  renderCell: (
    cell: unknown,
    row: VisitorPassQueryResponse
  ) => React.ReactNode;
  renderForCSV: (
    cell: unknown,
    visitorPass: VisitorPassQueryResponse
  ) => string;
};

function formatInviteNameCellValue(inviteName: string | undefined | null): string {
  return inviteName ?? '';
}

/** Invite name column for visitor log tables; enable only when VisitorInviteName flag is on. */
export function getVisitorLogInviteNameColumns(
  t: TFunction,
  isEnabled: boolean | undefined
): VisitorLogInviteNameColumn[] {
  if (!isEnabled) {
    return [];
  }

  return [
    {
      header: t('web.admin.channel.visitor.log.columns.inviteName'),
      key: 'inviteName',
      renderCell: (_cell, row) => (
        <TruncateTextComponent
          text={formatInviteNameCellValue(row.inviteName)}
          maxLength={INVITE_NAME_MAX_DISPLAY_LENGTH}
        />
      ),
      renderForCSV: (_cell, visitorPass) =>
        formatInviteNameCellValue(visitorPass.inviteName),
    },
  ];
}
